import { render, staticRenderFns } from "./sr_syh_report.vue?vue&type=template&id=54412fb2&scoped=true"
import script from "./sr_syh_report.vue?vue&type=script&lang=js"
export * from "./sr_syh_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54412fb2",
  null
  
)

export default component.exports